import store from '../store';

export const PERMISSION_LEVEL_ADMIN = 'admin';
export const PERMISSION_LEVEL_TECHNICIAN = 'technician';
export const PERMISSION_LEVEL_TECHNICIAN_ANRE = 'technician-anre';
export const PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB = 'technician-anre-srb';

const policies = {
  [PERMISSION_LEVEL_ADMIN]: [
    PERMISSION_LEVEL_ADMIN,
    PERMISSION_LEVEL_TECHNICIAN,
    PERMISSION_LEVEL_TECHNICIAN_ANRE,
    PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB,
  ],
  [PERMISSION_LEVEL_TECHNICIAN]: [
    PERMISSION_LEVEL_TECHNICIAN,
    PERMISSION_LEVEL_TECHNICIAN_ANRE,
    PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB,
  ],

  /**
   * Repact has multiple ANRE providers:
   * - WALIXMAR  GAZ  INSTAL  SRL with PERMISSION_LEVEL_TECHNICIAN_ANRE
   * - SRB INSTAL TEAM SRL with PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB is the second provider
   *
   * All of them are allowed to access the same permissions, but each one has its own files.
   */
  [PERMISSION_LEVEL_TECHNICIAN_ANRE]: [
    PERMISSION_LEVEL_TECHNICIAN_ANRE,
    PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB,
  ],
  [PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB]: [
    PERMISSION_LEVEL_TECHNICIAN_ANRE,
    PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB,
  ],
};

/**
 * Check for the current permission level if he is allowed to access the permissions of other role
 */
export const hasAccess = (permission) =>
  policies[store.getters['auth/getRole']].includes(permission);

export const hasRole = (role) => store.getters['auth/getRole'] === role;
